@if (isCompanyCapturePermissionsFixture) {
  <p role="note">Synthetic local preview. No HubSpot connection or customer data is changed.</p>
  <app-enrich-settings />
}
@if (showSubUnitPreviewFixture) {
  <main class="settings-fixture-shell">
    <div class="settings-container view">
      <mat-card class="cardPlain">
        <div class="custom-card-header">
          <div class="section-header">
            <div class="fixture-breadcrumb">Shine Enrich / Settings</div>
            <h1 class="m-0 f-w-500">HubSpot Settings</h1>
            <p class="m-0 help-text">Manage sync defaults and property mappings for Shine Enrich.</p>
          </div>
        </div>
        <mat-card-content class="d-flex flex-col gap-24">
          <mat-tab-group class="webinar-tabs" animationDuration="0ms" [selectedIndex]="2">
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>tune</mat-icon>
                <span>Configuration</span>
              </ng-template>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>schema</mat-icon>
                <span>Property mapping</span>
              </ng-template>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>play_circle</mat-icon>
                <span>Operations</span>
              </ng-template>
              <ng-template matTabContent>
                @if (isCompanyCaptureFixture) {
                  <section class="tab-section d-flex flex-col gap-12">
                    <div class="section-header"><h4 class="m-0 f-s-16 f-w-600">Company capture</h4><p class="m-0 f-s-14 text-gray-100">Synthetic localhost preview; no customer data or API calls.</p></div>
                    <mat-slide-toggle [(ngModel)]="companyCaptureSelectionRequired">Require company selection</mat-slide-toggle>
                    <mat-card class="code-card"><div class="code-card__header"><mat-card-title>Hosted autocomplete script</mat-card-title></div><pre><code>window.shineEnrichCompanyCaptureSettings = &#123; requireCompanySelection: true, selectionRequiredMessage: 'Please select a company from the list.' &#125;;
&lt;script async src="https://api.shine-enrich.intuvio.com/company-capture/v1.js"&gt;&lt;/script&gt;</code></pre></mat-card>
                    @if (companyCaptureSelectionRequired) {
                      <p class="m-0 f-s-14 text-gray-100">Validation message: Please select a company from the list.</p>
                    }
                  </section>
                } @else {
                <div class="tab-content d-flex flex-col gap-16">
                  <section class="tab-section d-flex flex-col gap-12">
                    <div class="section-header">
                      <h4 class="m-0 f-s-16 f-w-600">Full company sync</h4>
                      <p class="m-0 f-s-14 text-gray-100">
                        Start manual sync jobs and monitor their progress from sync history.
                      </p>
                    </div>
                    <div class="operation-panel">
                      <div class="operation-panel__body">
                        <mat-icon class="operation-panel__icon">sync</mat-icon>
                        <div class="d-flex flex-col gap-6">
                          <strong>Sync all HubSpot companies</strong>
                          <span class="m-0 f-s-14 text-gray-100">Runs a full CRM sync job outside this read-only preview.</span>
                        </div>
                      </div>
                      <div class="operation-panel__actions">
                        <button class="d-inline-flex align-items-center gap-6" color="primary" disabled mat-stroked-button type="button">
                          <mat-icon>sync</mat-icon>
                          Sync all companies now
                        </button>
                        <button class="d-inline-flex align-items-center gap-6" color="primary" mat-button type="button">
                          <mat-icon>history</mat-icon>
                          View sync history
                        </button>
                      </div>
                    </div>
                  </section>
                  <section class="tab-section d-flex flex-col gap-12">
                    <app-dnb-usage-card />
                  </section>

                  <section class="tab-section d-flex flex-col gap-12">
                    <div class="section-header">
                      <h4 class="m-0 f-s-16 f-w-600">Registry cache</h4>
                      <p class="m-0 f-s-14 text-gray-100">
                        Inspect the shared Nordic registry cache used by Shine Enrich.
                      </p>
                    </div>
                    <div class="operation-panel">
                      <div class="operation-panel__body">
                        <mat-icon class="operation-panel__icon">database</mat-icon>
                        <div class="d-flex flex-col gap-6">
                          <strong>Managed registry data</strong>
                          <span class="m-0 f-s-14 text-gray-100">Shine maintains the shared registry cache centrally.</span>
                        </div>
                      </div>
                      <div class="operation-panel__actions">
                        <button class="d-inline-flex align-items-center gap-6" disabled mat-button type="button">
                          <mat-icon>refresh</mat-icon>
                          Reload status
                        </button>
                      </div>
                    </div>
                  </section>

                  @if (isSubUnitPreviewState) {
                  <section class="tab-section d-flex flex-col gap-12">
                    <div class="section-header">
                      <h4 class="m-0 f-s-16 f-w-600">BRREG sub-unit preview</h4>
                      <p class="m-0 f-s-14 text-gray-100">
                        Review one bounded page of read-only sub-unit outcomes before any sync job runs.
                      </p>
                    </div>

                    @if (state === 'subunit-config-empty') {
                      <div class="registry-cache-note" data-testid="subunit-preview-config-empty">
                        <p class="m-0 f-s-14 text-gray-100">{{ subUnitPreviewConfigMessage }}</p>
                      </div>
                    } @else {
                      <div class="operation-panel">
                        <div class="operation-panel__body">
                          <mat-icon class="operation-panel__icon">visibility</mat-icon>
                          <div class="d-flex flex-col gap-6">
                            <strong>Preview BRREG sub-unit changes</strong>
                            <span class="m-0 f-s-14 text-gray-100">{{ subUnitPreviewImpactText }}</span>
                          </div>
                        </div>
                        <div class="operation-panel__actions">
                          <button
                            [disabled]="subUnitPreviewReloadDisabled"
                            class="d-inline-flex align-items-center gap-6"
                            color="primary"
                            mat-stroked-button
                            type="button"
                          >
                            <mat-icon>refresh</mat-icon>
                            Reload preview
                          </button>
                          <button
                            [disabled]="subUnitPreviewNextDisabled"
                            class="d-inline-flex align-items-center gap-6"
                            mat-button
                            type="button"
                          >
                            <mat-icon>arrow_forward</mat-icon>
                            Next page
                          </button>
                        </div>
                      </div>

                      @if (state === 'subunit-loading') {
                        <div class="subunit-preview-loading" data-testid="subunit-preview-loading">
                          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                          <p class="m-0 f-s-14 text-gray-100">Loading preview rows...</p>
                        </div>
                      }

                      @if (subUnitPreviewError) {
                        <div class="error-message" data-testid="subunit-preview-error">
                          <p>{{ subUnitPreviewError }}</p>
                        </div>
                      }

                      @if (subUnitPreview && !subUnitPreviewError) {
                        <div class="subunit-preview-summary" data-testid="subunit-preview-summary">
                          <article class="subunit-preview-summary__card">
                            <span>Total rows</span>
                            <strong>{{ subUnitPreview.summary.totalRows }}</strong>
                          </article>
                          <article class="subunit-preview-summary__card">
                            <span>Would create</span>
                            <strong>{{ subUnitPreview.summary.wouldCreateRows }}</strong>
                          </article>
                          <article class="subunit-preview-summary__card">
                            <span>Would update</span>
                            <strong>{{ subUnitPreview.summary.wouldUpdateRows }}</strong>
                          </article>
                          <article class="subunit-preview-summary__card">
                            <span>No-op</span>
                            <strong>{{ subUnitPreview.summary.noOpRows }}</strong>
                          </article>
                          <article class="subunit-preview-summary__card">
                            <span>Duplicates</span>
                            <strong>{{ subUnitPreview.summary.duplicateRows }}</strong>
                          </article>
                          <article class="subunit-preview-summary__card">
                            <span>Conflicts</span>
                            <strong>{{ subUnitPreview.summary.conflictRows }}</strong>
                          </article>
                        </div>

                        @if (subUnitPreviewRows.length === 0) {
                          <div class="registry-cache-note" data-testid="subunit-preview-empty">
                            <p class="m-0 f-s-14 text-gray-100">
                              No HubSpot companies with the configured sub-unit property were found on this page.
                            </p>
                          </div>
                        } @else {
                          <div class="subunit-preview-list">
                            @for (row of subUnitPreviewRows; track row.companyId) {
                              <article class="subunit-preview-row" data-testid="subunit-preview-row">
                                <div class="subunit-preview-row__header">
                                  <div class="subunit-preview-row__identity">
                                    <strong>{{ row.companyName }}</strong>
                                    <span class="m-0 f-s-13 text-gray-100">
                                      {{ row.companyId }} · {{ row.subUnitId }}
                                      @if (row.orgNumber) {
                                        · Org {{ row.orgNumber }}
                                      }
                                    </span>
                                  </div>
                                  <div class="subunit-preview-row__badges">
                                    <span class="preview-badge preview-badge--status preview-badge--{{ row.registryStatus }}">
                                      {{ previewRegistryStatusLabel(row) }}
                                    </span>
                                    @if (row.outcome) {
                                      <span class="preview-badge preview-badge--outcome">
                                        {{ row.outcome }}
                                      </span>
                                    }
                                    @for (issueCode of row.issueCodes; track issueCode) {
                                      <span class="preview-badge preview-badge--warning">
                                        {{ previewIssueLabel(issueCode) }}
                                      </span>
                                    }
                                  </div>
                                </div>

                                @if (row.registryCompanyName || row.parentOrgNumber) {
                                  <p class="m-0 f-s-13 text-gray-100">
                                    @if (row.registryCompanyName) {
                                      Registry: {{ row.registryCompanyName }}
                                    }
                                    @if (row.parentOrgNumber) {
                                      · Expected org {{ row.parentOrgNumber }}
                                    }
                                  </p>
                                }

                                @if (row.errorMessage) {
                                  <p class="m-0 f-s-13 text-gray-100">{{ row.errorMessage }}</p>
                                } @else if (row.diffPropertyCount === 0) {
                                  <p class="m-0 f-s-13 text-gray-100">No property differences on this page.</p>
                                } @else {
                                  <div class="subunit-preview-row__diffs">
                                    @if (row.createPropertyNames.length > 0) {
                                      <p class="m-0 f-s-13 text-gray-100">
                                        Create {{ row.createPropertyNames.length }}:
                                        {{ previewPropertyList(row.createPropertyNames) }}
                                      </p>
                                    }
                                    @if (row.updatePropertyNames.length > 0) {
                                      <p class="m-0 f-s-13 text-gray-100">
                                        Update {{ row.updatePropertyNames.length }}:
                                        {{ previewPropertyList(row.updatePropertyNames) }}
                                      </p>
                                    }
                                  </div>
                                }
                              </article>
                            }
                          </div>
                        }
                      }
                    }
                  </section>
                  }
                </div>
                }
              </ng-template>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>fact_check</mat-icon>
                <span>Company capture</span>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    </div>

    <section class="fixture-actions fixture-actions--settings">
      <a mat-stroked-button [routerLink]="['/enrich/settings']" [queryParams]="{tab: 2, enrichVisualFixture: 'subunit-config-empty'}">
        Config empty
      </a>
      <a mat-stroked-button [routerLink]="['/enrich/settings']" [queryParams]="{tab: 2, enrichVisualFixture: 'subunit-loading'}">
        Loading
      </a>
      <a mat-stroked-button [routerLink]="['/enrich/settings']" [queryParams]="{tab: 2, enrichVisualFixture: 'subunit-empty'}">
        Empty
      </a>
      <a mat-stroked-button [routerLink]="['/enrich/settings']" [queryParams]="{tab: 2, enrichVisualFixture: 'subunit-summary'}">
        Summary
      </a>
      <a mat-stroked-button [routerLink]="['/enrich/settings']" [queryParams]="{tab: 2, enrichVisualFixture: 'subunit-error'}">
        Error
      </a>
      <a mat-stroked-button [routerLink]="['/enrich/settings']" [queryParams]="{tab: 2, enrichVisualFixture: 'dnb-usage'}">
        D&amp;B usage
      </a>
    </section>
  </main>
} @else if (showReadinessFixture) {
  <main class="fixture-shell">
    <section class="fixture-header">
      <div>
        <p class="fixture-kicker">Local visual fixture</p>
        <h1>HubSpot Integration Readiness</h1>
        <p>
          {{ routeLabel }} route preview for <strong>{{ state }}</strong>.
          This route only matches on localhost with the <code>enrichVisualFixture</code> query parameter.
        </p>
      </div>
      <div class="fixture-route">
        <span>Route</span>
        <strong>{{ routeLabel }}</strong>
      </div>
    </section>

    <section class="readiness-panel" [class.readiness-panel--ready]="readiness.isOperationalReady">
      <div class="readiness-panel__header">
        <div>
          <h2>{{ readiness.isOperationalReady ? 'Operationally ready' : 'Action needed' }}</h2>
          <p>
            {{ readiness.isOperationalReady ? 'All blocking readiness checks are complete.' : 'Complete the blocking checks before using operational Enrich pages.' }}
          </p>
        </div>
      </div>
      <div class="readiness-grid">
        @for (item of readinessDimensions; track item.key) {
          <article class="readiness-item readiness-item--{{ item.status }}">
            <mat-icon>{{ readinessIcon(item.key) }}</mat-icon>
            <div class="readiness-item__body">
              <div class="readiness-item__title">
                <span>{{ item.label }}</span>
                <span>{{ readinessStatusLabel(item.key) }}</span>
              </div>
              <p>{{ item.message }}</p>
            </div>
          </article>
        }
      </div>
    </section>

    <section class="fixture-actions">
      <a mat-stroked-button [routerLink]="['/enrich/setup']" [queryParams]="{enrichVisualFixture: state}">
        Setup fixture
      </a>
      <a mat-stroked-button [routerLink]="['/enrich/settings']" [queryParams]="{enrichVisualFixture: state}">
        Settings fixture
      </a>
      <a mat-stroked-button [routerLink]="['/enrich/mapping']" [queryParams]="{setup: 'true', enrichVisualFixture: state}">
        Mapping fixture
      </a>
    </section>
  </main>
}
